// export const apiUrl = 'http://api.cz.365mooc.cn/';
// export const loginUrl = 'http://www.cz.com';


export const apiUrl = 'http://api.zhxy.czvtc.edu.cn/';
// export const apiUrl = 'http://api.cz.com'
export const loginUrl = 'http://www.zhxy.czvtc.edu.cn';




// WEBPACK FOOTER //
// ./src/api/config.js